// extracted by mini-css-extract-plugin
export default {"container":"_1kyN9XnJYpVQish4C8KA","card":"Ryv_FTCsO6L8K3e_Q6WD","title":"gDfaJHcRr2aeJO4jy8Mx"};